export class ApiObjHouseholdOption {

    // ========================================================================
    // === Hardcoded ids
    // ========================================================================

    static readonly ID_PERSON_RANDOM = 1;
    static readonly ID_MALE_RANDOM = 2;
    static readonly ID_FEMALE_RANDOM = 3;

    static readonly ID_PERSON_AGE_MAX = 4;
    static readonly ID_MALE_AGE_MAX = 5;
    static readonly ID_FEMALE_AGE_MAX = 6;
    
    static readonly ID_PERSON_AGE_MIN = 7;
    static readonly ID_MALE_AGE_MIN = 8;
    static readonly ID_FEMALE_AGE_MIN = 9;
    
    static readonly ID_PERSON_INCOME_MAX = 10;
    static readonly ID_MALE_INCOME_MAX = 11;
    static readonly ID_FEMALE_INCOME_MAX = 12;
    
    static readonly ID_PERSON_INCOME_MIN = 13;
    static readonly ID_MALE_INCOME_MIN = 14;
    static readonly ID_FEMALE_INCOME_MIN = 15;
    
    static readonly ID_PERSON_CAPITAL_INCOME_MAX = 16;
    static readonly ID_MALE_CAPITAL_INCOME_MAX = 17;
    static readonly ID_FEMALE_CAPITAL_INCOME_MAX = 18;
    
    static readonly ID_PERSON_CAPITAL_INCOME_MIN = 19;
    static readonly ID_MALE_CAPITAL_INCOME_MIN = 20;
    static readonly ID_FEMALE_CAPITAL_INCOME_MIN = 21;
    
    static readonly ID_PERSON_CAR_COUNT_MAX = 22;
    static readonly ID_MALE_CAR_COUNT_MAX = 23;
    static readonly ID_FEMALE_CAR_COUNT_MAX = 24;

    // ========================================================================
    // === Fields
    // ========================================================================

    public id: number;
    public name: string;
    public is_premium: boolean;
    public sort_order: number;

    // ========================================================================
    // === Create
    // ========================================================================

    constructor(data: any) {
        this.id = parseInt(data.id);
        this.name = data.name;
        this.is_premium = parseInt(data.is_premium) === 1;
        this.sort_order = parseInt(data.sort_order);
    }
}